export const actionType = {
  SEND_NOTIFICATION_START: 'NOTIFICATIONS/SEND_NOTIFICATION_START',
  SEND_NOTIFICATION: 'NOTIFICATIONS/SEND_NOTIFICATION',
  SEND_NOTIFICATION_FAIL: 'NOTIFICATIONS/SEND_NOTIFICATION_FAIL',
  SEND_NOTIFICATION_CLOSE_MESSAGE: 'NOTIFICATIONS/CLOSE_MESSAGE',
};
